import Dropdown from './dropdown';
import DropdownButton from './dropdown-button';
Dropdown.Button = DropdownButton;
export default Dropdown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/dropdown/index.js
// module id = 182
// module chunks = 0